// Helper functions for Cluster Optimizer components

// Helper function to convert memory values to bytes
export const parseMemory = (value: string): number => {
  let memoryInBytes = 0;
  
  if (value.endsWith('Ki')) {
    memoryInBytes = parseInt(value.slice(0, -2)) * 1024;
  } else if (value.endsWith('Mi')) {
    memoryInBytes = parseInt(value.slice(0, -2)) * 1024 * 1024;
  } else if (value.endsWith('Gi')) {
    memoryInBytes = parseInt(value.slice(0, -2)) * 1024 * 1024 * 1024;
  } else if (value.endsWith('Ti')) {
    memoryInBytes = parseInt(value.slice(0, -2)) * 1024 * 1024 * 1024 * 1024;
  } else {
    memoryInBytes = parseInt(value);
  }
  
  return memoryInBytes;
};

// Helper function to format memory values for display
export const formatMemory = (bytes: number): string => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let size = bytes;
  let unitIndex = 0;
  
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }
  
  return `${size.toFixed(1)} ${units[unitIndex]}`;
};

// Convert bytes to GB with 1 decimal place
export const bytesToGB = (bytes: number): string => {
  return (bytes / (1024 * 1024 * 1024)).toFixed(1);
};

// Helper function to determine node type based on taints
export const getNodeType = (node: any): 'gateway' | 'normal' => {
  const taints = node.spec?.taints || [];
  return taints.some((taint: any) => 
    taint.key === 'workload' && 
    taint.value === 'gateway' && 
    taint.effect === 'NoSchedule'
  ) ? 'gateway' : 'normal';
};

// Add a helper function to extract the last segment of the pod name (Pod ID)
export const extractPodId = (podName: string): string => {
  const parts = podName.split('-');
  return parts[parts.length - 1];
};

// Add a helper function to extract the deployment name from the pod name
export const extractDeploymentName = (podName: string): string => {
  // Extract everything before the last few segments which would be the pod ID
  // Assuming format like: deployment-name-random-id
  const parts = podName.split('-');
  if (parts.length <= 2) return podName; // Not enough segments
  
  // Get deployment name by removing the last segment (Pod ID)
  return parts.slice(0, -1).join('-');
};

// Helper for error messages
export const getErrorMessage = (error: any): string => {
  if (typeof error === 'string') return error;
  if (error?.message) return error.message;
  if (error?.data?.message) return error.data.message;
  return 'An unknown error occurred';
}; 